import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/backoffice-actions/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed = !!context.userPermissions.hasAllowedPermission({
      path: PAGE_PATHS.BACKOFFICE_ACTIONS,
      permission: Permission.UPDATE,
    });
    context.validatePermissions({ isAllowed, preload });
  },
});
